/* istanbul ignore file */
export const allowDay = (date: Date, weekdays: number[]) => {
  const day = date.getDay() - 1;
  const weekdayAllowed = weekdays ? weekdays.includes(day === -1 ? 6 : day) : true;
  return weekdayAllowed;
};

export const uniqOptions = (d: string[]) => [...new Set(d)].map((i) => ({ label: i, value: i }));
